<template>
  <div  class="" ref="posting">
      <div 
           :style="{'height': 200}"
            class="scroll-view"
            :scroll-y="true"
            >
        <div class="main">
            <input :height="scrollHeight" :maxlength="500" v @focus="focusIpt" @blur="blurIpt" placeholder="写下您的见解" type="textarea" />
        </div>
     </div>
      
      <!-- <div class="bottom" ref="bottom" :style="{'bottom': bottomVal + 'px', 'position': isFiexd ? 'absolute' : 'relative'}">
          <div class="edit-row">
             底部操作栏
          </div>
      </div> -->
      <div class="bottom" ref="bottom" :style="{'bottom': bottomVal + 'px', 'position': 'absolute'}">
          <div class="edit-row">
             底部操作栏
          </div>
      </div>
  </div>
</template>
<style lang="less" scoped>
    .scroll-view{
        position:relative;
        border:1px solid red;
        height:900px;
    }
    
</style>
<script>
export default {
  data() {
    return {
        bottomVal: 0,
        scrollHeight: 0,
        isFiexd: true,
        // windowH:0
    };
  },
  onLoad(e) {
  },
  mounted(){
      
      let windowH = window.innerHeight;
        this.windowH = windowH;
        this.bottomVal = 0
        setTimeout(()=>{this.scrollHeight = (windowH-196)+'rpx';},0)
        console.log('---初始化',this.scrollHeight);
  },
  methods: {
    blurIpt() {
        let windowH = window.innerHeight;
        this.windowH = windowH;
        this.bottomVal = 0
        this.scrollHeight = (windowH-196)+'rpx';
        console.log('---失去焦点', this.scrollHeight)
        // setTimeout(()=>{this.scrollHeight = `calc((${windowH} - 196)rpx)`},0)
       
       
    },
    focusIpt() {
        //获取焦点
        //获取系统信息
        // let info = this.getSystemInfoSync()
        // if(info.platform === 'ios') {
            // this.isFiexd= false;
            this.isFiexd = true
            setTimeout(() => {
                // console.log(this.$refs.bottom,this.$refs.bottom.$el);
                // this.$refs.bottom.$el.scrollIntoView()
                this.$refs.bottom.scrollIntoView()
                //获取文本区域高度
                let viewInfo = this.$refs.posting.getBoundingClientRect()
                console.log('----获取焦点，viewInfo',this.$refs.posting,viewInfo)
                //获取视图偏移量，重新定位操作栏
                this.bottomVal = Math.abs(parseFloat(viewInfo.top))
                 console.log('---bottomValue',this.bottomVal);
                //重置编辑区高度
                this.scrollHeight =  `calc(100vh - ${98 + this.bottomVal}px )`
                //还原偏移量
                scrollTo(0,0)
                this.isFiexd = true
            },500)
        // }
    },
  }
};
</script>
